<template>
    <div class="profile-photos info-block">
        <div class="section-header">
            <h2>
                <router-link :to="{
                    name: isVideo ? 'video-albums' : 'albums',
                    params: { profileId: id },
                }" class="link-inherit">
                    {{ isVideo ? $t("profile.video") : $t("profile.photos") }}
                </router-link>
                <span v-if="!instancesIsEmpty(type)" class="count">{{ count }}</span>
            </h2>
            <router-link v-if="!instancesIsEmpty(type)" :to="{
                name: isVideo ? 'video-albums' : 'albums',
                params: { profileId: id },
            }" class="link">
                <span class="mobile">
                    {{ $t("profile.allAlbums") }}
                </span>
                <div class="mob-not">
                    {{ $t("profile.viewAllAlbums") }}
                </div>
            </router-link>
        </div>
        <div v-if="instancesLoader" class="buttons-center">
            <button class="button-loader"></button>
        </div>
        <div v-else-if="instancesErrors.vip_settings">
            {{ $t("profile.view") }}
            {{ isVideo ? $t("profile.video") : $t("profile.photosIs") }}
            {{ $t("profile.availableOnlyFriendsVIPs") }}
        </div>
        <div v-else-if="!instancesIsEmpty(type)" class="profile-photos-row">
            <div v-if="id == user.id" @click="
                $modal.show('upload-photos', { myAlbums: true, isVideo: isVideo })
                " class="profile-photos-item profile-photos-item-add">
                <span class="link-blue-underlined">
                    {{ $t("profile.add") }}
                </span>
                <span class="link-blue-underlined">
                    {{ isVideo ? $t("profile.video") : $t("profile.photos") }}
                </span>
            </div>
            <div class="profile-photos-item" v-for="(instance, index) in instances" :key="instance.id" v-if="index < 5"
                @click="
                    $modal.show('photo-details', {
                        id: instance.id,
                        isVideo: isVideo,
                    })
                    ">
                <div class="profile-photos-inner" :class="{
                    puzzle: instance.album.album_type == 2,
                    'profile-photos-video': isVideo,
                }" :style="{
    'background-image': instance.image
        ? 'url(' + instance.image + ')'
        : '',
}">
                    <!-- <div v-if="instance.condition_type === 0" class="profile-photos-moderation"></div> -->
                    <div v-if="instance.condition_type === 0" class="profile-photos-moderation"></div>
                    <div v-if="isVideo && !instance.image" class="profile-photos-process">
                        <span v-if="instance.ready">
                            {{ $t("photos.videoProcessingError") }}
                        </span>
                        <span v-else>
                            {{ $t("photos.videoProcessing") }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="id == user.id" @click="$modal.show('upload-photos', { myAlbums: true, isVideo: isVideo })" class="profile-photos-add">
            <span class="link-blue-underlined">
                {{ $t("profile.add") }}
                {{ isVideo ? $t("profile.video") : $t("profile.photos") }}
            </span>
        </div>
        <div v-else class="text">
            {{ $t("profile.list") }}
            {{ isVideo ? $t("profile.video") : $t("profile.photo") }}
            {{ $t("profile.blank") }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModerationImg from "../../assets/img/moderator_icon.svg"

export default {
    name: "ProfileMedia",
    props: {
        i18n: Object,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            instancesLoader: true,
            isVideo: false,
            ModerationImg: ModerationImg,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
        }),
        instances() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true)
            ];
        },
        count() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true) + "Count"
            ];
        },
        instancesErrors() {
            return this.$store.getters[this.getMethod() + "/errors"];
        },
        instancesIsEmpty() {
            return this.$store.getters[this.getMethod() + "/isEmpty"];
        },
    },
    created() {
        this.isVideo = this.type == "videos";
        this.getInstances();
    },
    watch: {
        id(to, from) {
            if (to != from) {
                this.instancesLoader = true;
                this.isVideo = this.type == "video";
                this.getInstances();
            }
        },
    },
    methods: {
        getMethod(capitalize = false, method = "") {
            let str = this.isVideo ? "videos" : "photos";
            if (capitalize) str = str.charAt(0).toUpperCase() + str.slice(1);
            return str + method;
        },
        getInstances() {
            this.$store
                .dispatch(this.getMethod(false, "/getAll"), this.id)
                .then(() => {
                    this.instancesLoader = false;
                })
                .catch(() => {
                    this.instancesLoader = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_profile-media";
</style>
